// tslint:disable:max-line-length
import React from 'react';
interface IErrorLoadingIllustrationProps {
  dataTest: string;
  height?: number;
  width?: number;
}
export const ErrorLoadingIllustration: React.FC<IErrorLoadingIllustrationProps> = ({ dataTest, height, width }) => {
  return (
    <svg viewBox="0 0 255 155" aria-label="error loading" width={width} height={height} data-test={dataTest}>
      <g filter="url(#filter0_d_870_12970)">
        <rect x="96" y="4" width="151" height="83" rx="8" fill="#FFECE8" />
      </g>
      <path
        opacity="0.4"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M166 28.6013C166 33 168 53 172.5 53C177 53 179 33 179 28.6013C179 25.2026 176.09 21 172.5 21C168.91 21 166 24.2026 166 28.6013ZM168 66C168 68.7614 170.239 71 173 71C175.761 71 178 68.7614 178 66C178 63.2386 175.761 61 173 61C170.239 61 168 63.2386 168 66Z"
        fill="#B23E24"
      />
      <g filter="url(#filter1_d_870_12970)">
        <rect x="8" y="60" width="151" height="83" rx="8" fill="white" />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78 84.6013C78 89 80 109 84.5 109C89 109 91 89 91 84.6013C91 81.2026 88.0899 77 84.5 77C80.9102 77 78 80.2026 78 84.6013ZM80 122C80 124.761 82.2386 127 85 127C87.7614 127 90 124.761 90 122C90 119.239 87.7614 117 85 117C82.2386 117 80 119.239 80 122Z"
        fill="#DFE3E8"
      />
      <defs>
        <filter
          id="filter0_d_870_12970"
          x="88"
          y="0"
          width="167"
          height="99"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_870_12970" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_870_12970" result="shape" />
        </filter>
        <filter
          id="filter1_d_870_12970"
          x="0"
          y="56"
          width="167"
          height="99"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="4" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_870_12970" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_870_12970" result="shape" />
        </filter>
      </defs>
    </svg>
  );
};
